import { TFunction } from "i18next";
import {
  FieldType,
  FieldTypeType,
  getUnitDisplayName,
  OptionType,
  Unit,
} from "../../../services/helpers/types";

export const getOptions = (t: TFunction): OptionType[] => {
  const OPTIONS: OptionType[] = [
    {
      name: "Žiadna",
      value: "",
      position: 1,
      optionID: -1,
      fieldID: 4,
    },
    {
      name: getUnitDisplayName(t)[Unit.Degrees],
      value: Unit.Degrees,
      position: 2,
      optionID: 0,
      fieldID: 4,
    },
    {
      name: getUnitDisplayName(t)[Unit.MgPerLiter],
      value: Unit.MgPerLiter,
      position: 3,
      optionID: 1,
      fieldID: 4,
    },
    {
      name: getUnitDisplayName(t)[Unit.MMolPerLiter],
      value: Unit.MMolPerLiter,
      position: 4,
      optionID: 2,
      fieldID: 4,
    },
  ];
  return OPTIONS;
};

export const getAddTextUnitField = (t: TFunction): FieldType => {
  const ADD_TEXT_UNIT_FIELD: FieldType = {
    fieldID: 5,
    name: "SelectField",
    position: 5,
    type: FieldTypeType.Select,
    noteOption: false,
    defaultValue: "",
    options: getOptions(t),
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return ADD_TEXT_UNIT_FIELD;
};
